var sortAscending = require('./sortAscending');

function sortDescending(objArray, propertyName) {
	return sortAscending(objArray, propertyName).reverse();
}

module.exports = sortDescending;